"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAndMountAnsViewComponent = exports.renderAndMountComp = exports.renderAndMountComponent = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ReactDOM = tslib_1.__importStar(require("react-dom"));
var __1 = require("../..");
var renderAndMountComponent = function (component) {
    var elem = document.createElement('div');
    elem.id = 'test-root-container';
    document.body.appendChild(elem);
    ReactDOM.render(component, elem);
    return elem;
};
exports.renderAndMountComponent = renderAndMountComponent;
var renderAndMountComp = function (Comp, props) {
    var elem = document.createElement('div');
    elem.id = 'test-root-container';
    document.body.appendChild(elem);
    ReactDOM.render(React.createElement(Comp, props), elem);
    return elem;
};
exports.renderAndMountComp = renderAndMountComp;
/* Deprecated!!! */
var renderAndMountAnsViewComponent = function (Comp, props) {
    (0, __1.deprecatedMsg)("renderAndMountAndViewComponent is deprecated. Please use 'renderAndMountComp' with 'testViewCompPropsCreator'");
    var t = (0, __1.createTranslateFn)(function (key) { return key; });
    var p = tslib_1.__assign({ t: t }, props);
    return (0, exports.renderAndMountComponent)(React.createElement(Comp, p));
};
exports.renderAndMountAnsViewComponent = renderAndMountAnsViewComponent;
//# sourceMappingURL=render-and-mount.js.map